import { render } from "./service_management.html?vue&type=template&id=c4be0cd6&external"
import script from "./service_management.js?vue&type=script&lang=js&external"
export * from "./service_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__